var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pen 01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeWidth: 1,
    fill: "#9CA3AF",
    stroke: "#9CA3AF"
  }, /*#__PURE__*/React.createElement("line", {
    id: "butt_color",
    "data-name": "butt color",
    x1: 13,
    y1: 7,
    x2: 9,
    y2: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.5 14.5 0.5 15.5 1.5 10.5 11.5 0.5 15.5 4.5 5.5 14.5",
    fill: "none",
    stroke: "#9CA3AF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-cap": "butt"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen01);
export default __webpack_public_path__ + "static/media/pen-01.e916687a.svg";
export { ForwardRef as ReactComponent };